import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Compact VenturaZ Trust Score badge.
 * Colours ladder from HighRisk → Verified.
 * Props: total (0-100), label (string), size ('sm'|'md'), testIdPrefix
 */
const TONES = {
  "Verified":         { border: "border-emerald-400/70", text: "text-emerald-600", bg: "bg-emerald-50" },
  "Investor Ready":   { border: "border-gold/70",        text: "text-amber-700",   bg: "bg-gold/10"    },
  "Almost Ready":     { border: "border-sky-400/70",     text: "text-sky-700",     bg: "bg-sky-50"     },
  "Needs Review":     { border: "border-orange-400/70",  text: "text-orange-700",  bg: "bg-orange-50"  },
  "High Risk":        { border: "border-rose-500/70",    text: "text-rose-700",    bg: "bg-rose-50"    },
  "Insufficient Data":{ border: "border-slate-300",      text: "text-slate-500",   bg: "bg-slate-50"   },
};

export default function TrustBadge({ total, label, size = "sm", testIdPrefix = "trust" }) {
  if (total === null || total === undefined) return null;
  const tone = TONES[label] || TONES["Insufficient Data"];
  const isSm = size === "sm";
  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-full border ${tone.border} ${tone.bg} ${tone.text} ${isSm ? "px-2 py-0.5 text-[11px]" : "px-3 py-1 text-xs"} font-mono font-medium`}
      data-testid={`${testIdPrefix}-badge`}
      title={`VenturaZ Trust Score: ${total}/100 · ${label}`}
    >
      <ShieldCheck size={isSm ? 10 : 12} className="opacity-80" />
      <span className="tracking-wide">Trust {total}</span>
      {!isSm && <span className="opacity-70">· {label}</span>}
    </div>
  );
}
